module.exports = __webpack_public_path__ + "img/img_work_step_3_bg.205aaf41.jpg";